import React from "react";
import { Form, Select } from "antd";
const { Option } = Select;

const Edicao = ({ edicaoSelecinado, handleChangeSelectEdicao, estabelecimentoSelecinado, edicoes, getFieldDecorator }) => (
    <Form.Item label="Edição">
        {getFieldDecorator("edicao", {
            rules: [{ required: true, message: "Campo obrigatório" }],
            initialValue: edicaoSelecinado
        })(
            <Select placeholder="Selecionar" allowClear={true} onChange={handleChangeSelectEdicao} disabled={!estabelecimentoSelecinado}>
                {edicoes.map(edicao => (
                    <Option key={edicao.id} value={edicao.id}>
                        {edicao.nome}
                    </Option>
                ))}
            </Select>
        )}
    </Form.Item>
);

export default Edicao;
